<template>
  <div class="nav-bar-container">
    <div class="nav-bar">
      <div class="logo-container">
        <img src="../assets/image/menu-logo.png" alt="" />
        <div class="title">
          <span>为改变</span>
        </div>
      </div>
      <div class="menu-btn-container">
        <div class="menu-list">
          <ul>
            <li
              v-for="(item, index) in menuList"
              :key="index"
              @click="checkMenuIndex(index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="language-btn">
          <span>简体中文</span>
        </div>
        <div class="menu-btn" @click="openMenu">
          <img src="../assets/image/icon-menu-black.png" alt="" />
        </div>
      </div>
    </div>
    <open-menu ref="menu"></open-menu>
  </div>
</template>

<script>
import openMenu from "./openMenu";
export default {
  components: {
    openMenu,
  },
  data() {
    return {
      menuList: [
        "首页",
        "案例展示",
        "解决方案",
        "服务内容",
        "联系我们",
        "关于我们",
      ],
    };
  },
  methods: {
    openMenu() {
      this.$refs.menu.open();
    },
    checkMenuIndex(index) {
      if (index == 0) {
        this.$router.push("/home");
      } else {
        if(this.$route.query.menuIndex!=index){
        this.$router.push({
          path: "/details",
          query: {
            menuIndex: index,
          },
        });
        }

      }
      this.$emit("indexChange", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-bar-container {
  width: 100%;
    min-width: 1240px;
  position: fixed;
  top: 0;
  z-index: 10;
  background: #ffffff;
  .nav-bar {
    max-width: 1200px;
    margin: 0 auto;
    height: 74px;
    /*padding: 0 120px;*/
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo-container {
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 107px;
        height: 20px;
        margin-right: 12px;
      }
      .title {
        height: 16px;
        border-left: 1px solid #c5c5c5;
        display: flex;
        align-items: center;
        padding-left: 12px;
        span {
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #000000;
          text-align: center;
        }
      }
    }
    .menu-btn-container {
      display: flex;
      align-items: center;
      .menu-list {
        ul {
          display: flex;
          li {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #000000;
            margin-right: 40px;
            cursor: pointer;
            user-select: none;
            // &:hover {
            //   opacity: 0.6;
            // }
          }
        }
      }
      .language-btn {
        width: 90px;
        height: 34px;
        border: 1px solid #000000;
        border-radius: 17px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        margin-right: 20px;
        cursor: pointer;
        user-select: none;
      }
      .menu-btn {
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;
        img {
          display: block;
          width: 34px;
          height: 34px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue